// GetOrderTicketById

import { OrderRepository } from "../Repository/OrderRepository";

export interface GetOrderTicketByIdUseCase {
  invoke: (id: number) => Promise<any>;
}

export class GetOrderTicketById implements GetOrderTicketByIdUseCase {
  private repo: OrderRepository;
  constructor(_Repo: OrderRepository) {
    this.repo = _Repo;
  }

   invoke(id: number){
    if(!id){
        throw new Error(
            "No tiene la data necesaria."
          );
    }
    const getData = this.repo.getOrderTicketById(id);
    return getData;
  }
}